<template>
  <div v-if="getPermission.stc.view">  

    <settlement-form ref="SettlementForm" mode="VIEW" :onUpdate="updatePayrollNum"/>

    <md-card class="searchPanel">
      <md-card-content>
        <div class="md-layout md-gutter">

          <div v-if="active" class="md-layout-item md-size-20 ">
           <div class = "inputBox">
              <datepicker v-model="searchRequest.settleDate.startDate">
                <label>Settle From</label>
              </datepicker>
            </div>
          </div>

          <div v-if="active" class="md-layout-item md-size-20 ">
           <div class = "inputBox">
              <datepicker v-model="searchRequest.settleDate.endDate">
                <label>Settle To</label>
              </datepicker>
            </div>
          </div>

          <div v-if="active" class="md-layout-item md-size-20 ">
            <div class = "inputBox">
              <md-field>
                  <label>Payroll#</label>
                  <md-input 
                  v-model="searchRequest.payrollNum" 
                  />
                </md-field>
            </div>
          </div>

          <div class = "md-layout-item md-size-35">
            <auto-complete-master-data-select
              group="STC_DRIVER_COMPANY"
              label="Driver Company"
              :on-item-changed="handleDriverCompanyChanged">
            </auto-complete-master-data-select>
          </div>

          <WindowPortal v-model="payrollItemStatus"> 
            <head>
              <title >Payroll#: {{payrollItem.payrollNumSeq}}</title>
            </head>

            <div class="page-header" >
              <div style="height: 20px"></div>
              <h1 class = "heading1 centerPrint">Detail Driver Settlement Report</h1>
              <div style="height: 20px"></div>
                <div class ="fContainer" >
                  <div class = "heading2"> Week Ending:  {{ payrollItem.settleWeekEnd }} : for {{drivercount}} driver(s) </div>
                  <div class = "heading2">Company: {{payrollItem.company}} </div>
                </div>
              <br/>
              <button id="printf" onclick="window.print()">Print this page</button>
            </div>

            <table>         
              <thead>
                <tr>
                  <td>
                    <div class="page-header-space"></div>
                  </td>
                </tr>
              </thead>    

              <tbody>
                <div class="page">
                  <div style="height: 5px"></div>
                  <h1 class = "heading2 ">Driver Settlement</h1>
                  <div style="height: 5px"></div>
                  <table id="headertable">
                    <th class="header-cell center1 w1" >Count</th>
                    <th class="header-cell center1 w3" >Driver</th>
                    <th class="header-cell center1 w3" >Date</th>
                    <th class="header-cell center1 w3" >Doc#</th>
                    <th class="header-cell center1 w3" >Load#</th>
                    <th class="header-cell center1 w4" >Ctnr#</th>
                    <th class="header-cell center1 w3" >Pickup</th>
                    <th class="header-cell center1 w4" >Delivery</th>
                    <th class="header-cell center1 w6" >Rate Desc</th>
                    <th class="header-cell center1 w2" >Rate</th>
                    <th class="header-cell center1 w1" >Qty</th>
                    <th class="header-cell center1 w2" >Tol</th>
                  </table>

                  <div class="table-body ">
                    <table id="bodytable">
                      <tbody>
                        <tr :key="item.vueKey" v-for="item in payrollprintitems"  >
                          <td class="body-cell excelBoxprint w1">{{item.rownumber}}</td>  
                          <td class="body-cell excelBoxprint w3">{{item.partner}}</td>
                          <td class="body-cell excelBoxprint w3">{{item.billingDate}}</td>
                          <td class="body-cell excelBoxprint w3">{{item.billingNum}}</td>  
                          <td class="body-cell excelBoxprint w3">{{item.seqNo  }}</td>
                          <td class="body-cell excelBoxprint w4">{{item.containerNo}}</td>
                          <td class="body-cell excelBoxprint w3">{{item.containerPickUpLocation }}</td>
                          <td class="body-cell excelBoxprint w4">{{item.containerDropOffLocation}}</td>
                          <td class="body-cell excelBoxprint w6">{{item.rdesc}}</td>
                          <td class="body-cell excelBoxprint w2">{{item.amt}}</td>
                          <td class="body-cell excelBoxprint w1">{{item.qty}}</td>
                          <td class="body-cell excelBoxprint w2">{{item.tol}}</td>                  
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div class ="fContainer" >
                    <div class = "heading2">---------------------------------------------------------------------------------------------------------------------------------- </div>
                  </div>
                  <div style="height: 5px"></div>
                  <div class ="fContainer" >
                    <div class = "heading2 addspaceright"> Total Payroll Count:   {{this.totalrownumber}} </div>
                    <div class = "heading2 addspaceright">Grosss Amount: $  {{payrollItem.grossAmt}} </div>
                  </div>
                  <div style="height: 5px"></div>
                  <div class ="fContainer" >
                    <div class = "heading2">---------------------------------------------------------------------------------------------------------------------------------- </div>
                  </div>
                  <div style="height: 5px"></div>
                  <div class ="fContainer" >
                    <div class = "heading2"> Standard Adjustment</div>
                    <div class = "heading2 addSpaceright10">Deductions</div>
                    <div class = "heading2 addSpaceright10">Additions</div>
                    <div class = "heading2"></div>
                  </div>

                  <div class ="fContainer" >
                    <div class = "heading2 ">----------------------- </div>
                    <div class = "heading2 addSpaceright10  ">------------------</div>
                    <div class = "heading2 addSpaceright10  ">------------------</div>
                    <div class = "heading2"></div>
                  </div>

                  <div class ="fContainer" >
                    <div class = "heading2 addSpace "> Scale</div>
                    <div class = "heading2  addSpaceright "> {{payrollItem.amtScaleDeduction1 }}</div>
                    <div class = "heading2  addSpaceright "> {{payrollItem.amtScaleAddition1 }}</div>
                    <div class = "heading2"></div>
                  </div>
                  <div style="height: 5px"></div>
                  <div class ="fContainer" >
                    <div class = "heading2 addSpace"> Insurance </div>
                    <div class = "heading2 addSpaceright ">{{payrollItem.amtInsuranceDeduction1}}  </div>
                    <div class = "heading2 addSpaceright ">{{payrollItem.amtInsuranceAddition1}}  </div>
                    <div class = "heading2"></div>
                  </div>
                  <div style="height: 5px"></div>
                  <div class ="fContainer" >
                    <div class = "heading2 addSpace"> Parking</div>
                    <div class = "heading2 addSpaceright ">{{payrollItem.amtParkingDeduction1}}  </div>
                    <div class = "heading2 addSpaceright ">{{payrollItem.amtParkingAddition1}}  </div>
                    <div class = "heading2"></div>
                  </div>
                  <div style="height: 5px"></div>
                  <div class ="fContainer" >
                    <div class = "heading2 addSpace"> Manifest Booklet</div>
                    <div class = "heading2 addSpaceright ">{{payrollItem.amtManifestDeduction1}}  </div>
                    <div class = "heading2 addSpaceright ">{{payrollItem.amtManifestAddition1}}  </div>
                    <div class = "heading2"></div>
                  </div>
                  <div class ="fContainer" >
                    <div class = "heading2 ">------------------------ </div>
                    <div class = "heading2 addSpaceright10  ">-------------------</div>
                    <div class = "heading2 addSpaceright10  ">-------------------</div>
                    <div class = "heading2"></div>
                  </div>
                  <div class ="fContainer" >
                    <div class = "heading2 ">Adjustment Subtotal</div>
                    <div class = "heading2  addSpaceright"> $({{payrollItem.totStdDeduction}})</div>
                    <div class = "heading2  addSpaceright"> ${{payrollItem.totStdAddition}}</div>
                    <div class = "heading2"></div>
                  </div>
                  <div style="height: 5px"></div>
                  <div class ="fContainer" >
                    <div class = "heading5">----------------------------------------------------------------------------------------------------------------------- </div>
                  </div>
                  <div style="height: 5px"></div>
                  <div class ="fContainer" >
                    <div class = "heading2"> Misc. Deductions & Additions:</div>
                  </div>
                  <div style="height: 5px"></div>
                  <div class ="fContainer" >
                  </div>

                  <div style="height: 5px"></div>
                  <div class ="fContainer" >
                    <div class = "heading2 addSpace"> {{payrollItem.misAdjreason}}</div>
                    <div class = "heading2  addSpaceright ">$({{payrollItem.totMisDeduction  }})</div>
                    <div class = "heading2  addSpaceright ">${{ payrollItem.totMisAddition}}</div>
                    <div class = "heading2"></div>
                  </div>

                  <div style="height: 5px"></div>
                  <div class ="fContainer" >
                    <div class = "heading2">________________________________________________________________________________________ </div>
                  </div>

                  <div style="height: 5px"></div>
                  <div class ="fContainer" >
                    <div class = "heading2 "> Total Gross Pay: </div>
                    <div class = "heading2 addSpace"> $ {{payrollItem.grossAmt}}  </div>
                    <div class = "heading2 ">    </div>
                    <div class = "heading2 addSpace">  </div>
                  </div>
              
                  <div style="height: 5px"></div>
                  <div class ="fContainer" >
                    <div class = "heading2 "> Total Adjustments:  </div>
                    <div class = "heading2 addSpace"> $({{payrollItem.totoalAdj}})   </div>
                    <div class = "heading2 "> Net Settlement Amount:  </div>
                    <div class = "heading4 addSpace"> ${{payrollItem.netAmt}} </div>
                  </div>
                  <div class ="fContainer" >
                    <div class = "heading2 ">  </div>
                    <div class = "heading2 addSpace">  </div>
                    <div class = "heading2 ">  </div>
                    <div class = "heading2 ">__________________</div>
                  </div>
                </div>
              </tbody>

              <div class="page-footer">
                <div class ="fContainer" >
                  <div class = "foot1"> Payroll#:  {{payrollItem.payrollNumSeq}} </div>
                  <div class = "foot1"> Print By: {{this.getUserProfile.name}}</div>
                  <div class = "foot1">  Print date:  {{payrollItem.printDate}} </div>
                </div>
                
              </div>

              <tfoot>
                <tr>
                  <td>
                    <div class="page-footer-space"></div>
                  </td>
                </tr>
              </tfoot>
            </table>    
          </WindowPortal>

          <div v-if="getPermission.stc.view" class="md-layout-item md-size-100 md-small-size-100">
            <callingApiCenter :paths="['/api/w/apar/settelmentrpt']">
              <callingApiCenter path=" /api/w/apar/settelmentrpt" :not-display-error="true">
                <md-button id = "searchTag" @click="doSearch"  class=" custButton btn-search-special-form-container md-primary md-raised" ><span class="icons-center material-icons">supervised_user_circle</span>Search</md-button>
                <md-button class="md-raised custButton" @click="doClear"><span class="icons-center material-icons">cached</span>Reset</md-button>
                <md-button class="md-raised custButton md-primary" :disabled="!canEdit" @click="doDetail"><span class="icons-center material-icons">undo</span>Detail</md-button>
                <md-button class="md-raised custButton md-primary" :disabled="!canEdit" @click="doPDF"><span class="icons-center material-icons">picture_as_pdf</span>PDF</md-button>
                <md-button class="md-raised custButton md-primary" :disabled="!canEdit" @click="doPrint"><span class="icons-center material-icons">print</span>Payroll Print</md-button>
                <md-button class="md-raised custButton md-accent" :disabled="!canEdit" @click="doUnsettle" v-debounce:click="3000"><span class="icons-center material-icons">undo</span>Un-Settle</md-button>
              </callingApiCenter>
            </callingApiCenter>
          </div>
        </div>
      </md-card-content>
    </md-card>

    <pagination :items="filteredRows">
      <template slot-scope="{pageItems}">
        <md-card class="data-table-container">
          <div class="outer-container">
            <div class="inner-container">
              <div class="table-header">
                <table id="headertable">
                  <thead>
                    <tr>
                      <th class="header-cell w2">
                        <!-- <md-checkbox v-model="selectAll" @change="changeSelChkBox"></md-checkbox>
                        <md-tooltip md-direction="top">All</md-tooltip> -->
                      </th>
                      <th class="header-cell center w5" v-on:click="sortFunction('payrollNumSeq')">Payroll#</th>
                      <th class="header-cell center w4" v-on:click="sortFunction('settleDate')">SettleDate</th>
                      <th class="header-cell center w10" v-on:click="sortFunction('driverCompany')">Driver Company</th>
                      <th class="header-cell center w4" v-on:click="sortFunction('grossAmt')">Gross Amt</th>
                      <th class="header-cell center w4" v-on:click="sortFunction('standardAdj')">STD.Adj</th>
                      <th class="header-cell center w4" v-on:click="sortFunction('miscAdj')">Misc.Adj</th>
                      <th class="header-cell center w4" v-on:click="sortFunction('netAmt')">Net Amt</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('createdBy')">CreatedBy</th>
                      <th class="header-cell center w4" v-on:click="sortFunction('createdAt')">CreatedDate</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('changeBy')">PrintedBy</th>
                      <th class="header-cell center w4" v-on:click="sortFunction('changeAt')">PrintedDate</th>
                    </tr>  
                  </thead>
                </table>
              </div>

              <div class="table-body " @scroll="handleScroll">
                <table id="bodytable">
                  <tbody>
                    <tr :key="item.vueKey" v-for="item in pageItems" v-bind:class ="{ selected: item.selected }">
                      <td class="body-cell w2 ">
                        <md-checkbox v-if="item.payrollNum != 'TBA'" v-model="item.selected">
                        </md-checkbox>
                      </td>
                      <td class="body-cell excelBox w5">{{item.payrollNumSeq}}</td> 
                      <td class="body-cell excelBox w4">{{item.settleDate | date}}</td> 
                      <td class="body-cell excelBox w10"><master-data-display group="STC_DRIVER_COMPANY" :tag-id="item.driverCompany"/></td>
                      <td class="body-cell excelBox w4">{{item.grossAmt }}</td>
                      <td class="body-cell excelBox w4">{{item.standardAdj}}</td>
                      <td class="body-cell excelBox w4">{{item.miscAdj}}</td>
                      <td class="body-cell excelBox w4">{{item.netAmt}}</td>     
                      <td class="body-cell excelBox w5">{{item.createdBy}}</td>
                      <td class="body-cell excelBox w4">{{item.createdAt | date}}</td>
                      <td class="body-cell excelBox w5">{{item.updatedBy}}</td>
                      <td class="body-cell excelBox w4">{{item.updatedAt | date}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </md-card>
      </template>
    </pagination>
  </div>
</template>

<style scoped>

@media print {
  #printf {
    display: none; 
  }
  thead {
      display: table-header-group;
    }
    tfoot {
      display: table-footer-group;
    }
  }
  .excelBoxprint {
    padding-top: 1px;
    padding-bottom: 1px;
    padding-left: 1px;
    padding-right: 1px;
    text-align: center;
    font-size: 10px;
  }
  .fContainer {
  display: flex;
  flex-direction: row;
  /* background-color:grey; */
  }
  .heading1 {
    padding-top: 30px;
    padding-left: 0px;
    margin-bottom: 0;
    color: black;
    width: 100%;
    font-size: 20px;
    font-family: Roboto Slab;
    margin: auto;
  }
  .heading2 {
    padding-top: 0px;
    padding-left: 0px;
    margin-bottom: 0;
    color: black;
    width: 100%;
    font-size: 16px;
    font-family: Roboto Slab;
    margin: auto;
  }
  .heading3 {
    padding-top: 0px;
    padding-left: 0px;
    margin-bottom: 0;
    color: black;
    width: 100%;
    font-size: 18px;
    font-family: Roboto Slab;
    margin: auto;
  }
  .heading4 {
    padding-top: 0px;
    padding-left: 0px;
    margin-bottom: 0;
    color: black;
    width: 100%;
    font-size: 30px;
    font-family: Roboto Slab;
    margin: auto;
  }
  .heading5 {
    padding-top: 0px;
    padding-left: 0px;
    margin-bottom: 0;
    color: black;
    width: 100%;
    font-size: 5px;
    font-family: Roboto Slab;
    margin: auto;
  }
  .foot1 {
    padding-top: 0px;
    padding-left: 0px;
    margin-bottom: 10;
    color: black;
    width: 100%;
    font-size: 12px;
    font-family: Roboto Slab;
    margin: auto;
  }
  .centerPrint {
  margin: auto;
  width: 100%;
  padding: 10px;
  text-align: center;
  }
  .addSpace{
    padding-left: 30px;
    text-align: left;
  }
  .addSpaceright{
    padding-right: 50px;
    text-align: right;
  }
  .addSpaceright10{
    padding-right: 10px;
    text-align: right;
  }
  .addSpaceright15{
    padding-right: 0px;
    text-align: right;
  }
  .excelBoxLeft {
    padding-top: 15px;
    padding-bottom: 15px;
    padding-left: 5px;
    padding-right: 5px;
  }
  .page-header,
  .page-header-space {
    height: 100px;
  }
  .page-footer,
  .page-footer-space {
    height: 100px;
  }
  .page-footer {
    position: fixed;
    /* position: absolute; */
    bottom: 0px;
    width: 100%;
    border-top: 1px solid black; /* for demo */
    /* background: rgb(247, 247, 245);  */
  }
  .page-header {
    position: fixed;
    /* position: absolute; */
    top: 0mm;
    width: 100%;
    border-bottom: 1px solid black; /* for demo */
    background: rgb(250, 250, 248); /* for demo */
  }
  .page {
    page-break-after: none;
  }
  @page {
    /* size: A4 landscape; */
    margin: 20;
   
  }
  .icons-center {
        vertical-align: bottom;
        margin-right: 10px;
        color: rgb(165, 236, 227);
        font-size: 25px;
    }
  .lable-center {
      vertical-align: bottom;
      margin-left: 20px;
      font-size: 20px;
      color: #010855;
  }
  .data-center {
      vertical-align: bottom;
      font-size: 20px;
      color: #0b21e9;
  }
  .inputBox {
      border: 1px solid #cacbcc;
      border-radius: 5px;
      color: #29303b;
      font-size: 18px;
      height: auto;
      line-height: 1.5em;
      padding: 5px 5px 5px 5px;
      margin-top: 5px;
  }
  .selected {
      background: rgb(217, 204, 255);
  }
  .center {
      text-align: center;
  }


  .center1 {
      text-align: center;
      font-size: 10px;
  }
  .custButton {
      margin: 10px;
      width: 120px;
      height: 40px;
      line-height:40px;
      font-size: 0.8rem;
  }
  .custSearchBar{
      margin: 10px;
      width: 200px;
      height: 40px;
      line-height:40px;
      font-size: 0.9rem;
      color: blue;
  }
  .custButtonRight {
      margin: 10px;
      width: 100px;
      height: 40px;
      float : right;
      color: green;
  }
</style>


<script>
  import { mapGetters } from 'vuex';
  //import api from "../api";
  import { newAPIPost } from '../api/index.js';
  import callingApiCenter from "../components/CallingApiCenter.vue";
  import AutocompleteCcicLocationSelect from "../components/AutocompleteCcicLocationSelect.vue";
  import SettlementForm from '../components/SettlementForm.vue';
  import moment from 'moment';
  import jsPDF from 'jspdf';
  import 'jspdf-autotable';
  import WindowPortal from '../components/WindowPortal.vue';

  const getInitSearch = () => ({
    mode: "list",
    salesOffice: "LGB",
    payrollNum: null,
    driverCompany: null,
    settleDate: {
      startDate: null,
      endDate: null
    },
    selected: false,

  });
  export default {
    data: () => ({
      searchRequest: getInitSearch(),
      billings: [],
      active: true,
      items: [],
      settlement: [],
      sortStatus: true,
      filter:"",
      selectAll: false,
      payrollprintitems: [],
      payrollItemStatus: false,
      payrollItem: [],
      totalrownumber: 1 ,
      drivercount: 1 ,
      checkLok: [],
    }),

    components: {
      AutocompleteCcicLocationSelect,
      callingApiCenter,
      SettlementForm,
      WindowPortal,
    },

    watch: {
      getpayrollSettleRpt(val) {
        this.updateItems(val);
      },
    },

    computed: {
      ...mapGetters([
        'getPermission',
        'getUserProfile',
        'getMasterDataName',
        'getRole',
        'getpayrollSettleRpt',
      ]),

      filteredRows(){
        return this.items.filter(row => {
          const term = this.filter.toUpperCase();
          return this.includeNull(row.payrollNumSeq).includes(term) ||
                  this.includeNull(row.settleDate).includes(term) ||
                  this.includeNull(row.driverCompany).includes(term);
        })
      },

      canEdit() {
              return this.getSelectedItems.length === 1;
      },

      getSelectedItems() {
        return _(this.items)
          .filter(it => it.selected);
      },
       

    },

    async mounted() {
      const today= moment().subtract(1,'weeks').toDate();
      this.searchRequest.settleDate.startDate = moment(today).startOf('week').toDate();
      this.searchRequest.settleDate.endDate = moment(today).endOf('week').toDate();
      this.searchRequest.salesOffice = 'LGB' ; 
      this.$el.querySelector('#searchTag').click();
      this.updateItems(this.getpayrollSettleRpt);
      
    },

    methods: {
      mouseOver: function(){
          this.active = true;
      },
      mouseLeave: function() {
        this.active = !this.active;
      },

      handleDriverCompanyChanged(id){
              this.searchRequest.driverCompany = id;
              this.$el.querySelector('#searchTag').click();
          },

      sortFunction(sortFiled){
        const sorted = _(this.items).sortBy(sortFiled);
        console.log(this.sortStatus)
        this.sortStatus = !this.sortStatus;
        if (this.sortStatus)
        {
            this.items = sorted;
        }
        else
        {
            this.items = sorted.reverse();
        }
      },

      changeSelChkBox() { 
        _(this.filteredRows).forEach(
          it => {
            it.selected = this.selectAll;
          }
        );
        this.updateItems(this.items);
      },
      
      updateItems(itemsSource) {
        var items = JSON.parse(JSON.stringify(itemsSource)) ;
        items.forEach((it) => {
          it.selected ;
        });
        this.items = items;         
      },

      async doUnsettle() {
        //this.checkLok = await api.post("/api/w/apar/stagelist", {
        this.checkLok = await newAPIPost("/api/w/apar/stagelist", {  
          salesOffice: "LGB",
          docType: "STAGE",
          payrollNum: this.getSelectedItems[0].payrollNumSeq,
          billingStatus: "LOK",
          billingDate:
          {
            startDate: "2000-01-01",
            endDate: "2999-12-31",
          },
            
        })
        
        if (this.checkLok.length > 0 )
        {
          window.confirm("Settlement " + this.getSelectedItems[0].payrollNumSeq + " is locked!" );
        }
        else
        {
          //api.post("/api/w/apar/paysettle", {
          newAPIPost("/api/w/apar/paysettle", {  
            username: this.getUserProfile.username,
            mode: "delete",
            salesOffice: "LGB",
            payrollNumSeq: this.getSelectedItems[0].payrollNumSeq,
          })
          .then((res) => {
            window.confirm("Payroll " + res + " un-settled!");
            this.doSearch();
            this.items.forEach( (it) => {
                if (it.payrollNum == "TBA" ) {
                    it.selected = false;
                }   
              });
          });
        }


      },        
    
      async doDetail() {
        this.$refs.SettlementForm.openDialog( this.getSelectedItems,  " ",  " ", " " );
      },

      async updatePayrollNum() {
        this.items.forEach( (it) => {
               if (it.payrollNum != "TBA" ) {
                  it.selected = false;
               }   
            });
      },

      doSearch() {
        this.active = true;
        this.selectAll = false; 
        if (this.searchRequest.settleDate.startDate == null)
        {
          window.confirm('Settle From is required!')
          return;
        }
        if (this.searchRequest.settleDate.endDate == null)
        {
          window.confirm('Settle To is required!')
          return;
        }

        this.$store.dispatch('payrollSettleRpt', this.searchRequest);
       },

      doClear(){
        // this.filter = "";
        this.searchRequest = getInitSearch();
        
        const today= moment().subtract(1,'weeks').toDate();
        this.searchRequest.settleDate.startDate = moment(today).startOf('week').toDate();;
        this.searchRequest.settleDate.endDate = moment(today).endOf('week').toDate();
            
        var items = JSON.parse(JSON.stringify(this.items));
          items.forEach((it) => {
            it.backGroud = false;
            it.selected = false;
            it.editing = false;
          });
          this.items = items;
      },

      handleScroll(e) {
        $(this.$el.querySelector('.table-header'))
          .offset({
            left: -1 * (e.target.scrollLeft - $('.outer-container')
              .offset().left),
          });
      },

      includeNull(field){
            return field==null ? '' : field;
      },

    getDisplay(group, tagId) {
          if (!tagId) {
            return "";
          }
          return this.getMasterDataName(group, tagId) || this.tagId;
        },

    async doPDF(){

      
      const item = _(this.items).filter((it) => it.selected);
      this.settlement = item[0];

      //this.billings = await api.post('/api/w/apar/settelmentlist',
      this.billings = await newAPIPost('/api/w/apar/settelmentlist',
                  { mode:"print",
                    salesOffice: "LGB",
                    payrollNumSeq: this.settlement.payrollNumSeq,
                  }
                );

      let info = []

      this.billings.forEach((element,index,array) => {
        info.push([element.partner,
                  element.containerNo,
                  element.chassisNo,
                  element.containerPickUpLocation,
                  element.containerDropOffLocation,
                  element.rdesc,
                  element.amt,
                  element.qty,
                  element.tol,
                  element.settleDate
                  ])
      });

      this.settlement.totStdDeduction = ( parseFloat(this.settlement.amtScaleDeduction1) +
                                        parseFloat(this.settlement.amtManifestDeduction1) +
                                        parseFloat(this.settlement.amtParkingDeduction1) +
                                        parseFloat(this.settlement.amtInsuranceDeduction1)).toFixed(2);

      this.settlement.totStdAddition = (  parseFloat(this.settlement.amtScaleAddition1) +
                                  parseFloat(this.settlement.amtManifestAddition1) +
                                  parseFloat(this.settlement.amtParkingAddition1) +
                                  parseFloat(this.settlement.amtInsuranceAddition1)).toFixed(2);

      this.settlement.totMisDeduction = ( parseFloat(this.settlement.rmk1Deduction) +
                                  parseFloat(this.settlement.rmk2Deduction) +
                                  parseFloat(this.settlement.rmk3Deduction) +
                                  parseFloat(this.settlement.rmk4Deduction) +
                                  parseFloat(this.settlement.rmk5Deduction)).toFixed(2);

      this.settlement.totMisAddition = ( parseFloat(this.settlement.rmk1Addition) +
                                        parseFloat(this.settlement.rmk2Addition) +
                                        parseFloat(this.settlement.rmk3Addition) +
                                        parseFloat(this.settlement.rmk4Addition) +
                                        parseFloat(this.settlement.rmk5Addition)).toFixed(2);

      this.settlement.company = this.getDisplay('STC_DRIVER_COMPANY', this.settlement.driverCompany);
      this.settlement.driver = 'Test Driver';
      const today = new Date();
      this.settlement.printDate =  moment(today).format('MM/DD/YYYY');
      this.settlement.settleWeekEnd = moment(this.settlement.settleDate).format('MM/DD/YYYY');

      const doc = new jsPDF({
        orientation: "landscape",
        
      });

      doc.text(95,10,'Detail Driver Settlement Report                 Date Printed: ' + this.settlement.printDate);
      doc.text(100,20,'Settlement: ' + this.settlement.payrollNumSeq);
      doc.text(15,30,'Vendor/Company: ' + this.settlement.company);
      doc.text(15,40,'Week Ending: ' + this.settlement.settleWeekEnd);
      doc.text(200,40,'Pay Group: Owner Operator');
    
      doc.text(100,50,'Gross Amount: '+ this.settlement.grossAmt);
      doc.text(100,60,'Total Std.Adjustment: '+ this.settlement.standardAdj);
      doc.text(100,70,'Total Mis.Adjustment: '+ this.settlement.miscAdj);
      doc.text(100,80,'Net Settlement Amount: '+ this.settlement.netAmt);


      doc.autoTable({ 
        margin: {top: 90},
        head: [['Driver','Container','Chassis','Pickup', 'Dropoff', 'Description', 'Rate', 'Qty', 'Total', 'Settle Date' ]],
        body: info,
        foot: [[,,,,,,,'Gross:', this.settlement.grossAmt,]]
      });
      // doc.text(200,+10,'Gross Amount: '+ this.settlement.grossAmt);

      doc.autoTable({
        head: [['Std.Adjustment','Dedcutions','Additions']],
        body:[
            ['Scale', this.settlement.amtScaleDeduction1,this.settlement.amtScaleAddition1],
            ['Insurance', this.settlement.amtInsuranceDeduction1, this.settlement.amtInsuranceAddition1],
            ['Parking', this.settlement.amtParkingDeduction1, this.settlement.amtParkingAddition1],
            ['Manifest', this.settlement.amtManifestDeduction1, this.settlement.amtManifestAddition1]
        ],
        foot: [['Total Std.Adjustment:',this.settlement.totStdDeduction,this.settlement.totStdAddition]]
        });
        // doc.text(200,+10,'Total Std.Adjustment: '+ this.settlement.standardAdj);

      // if ( this.settlement.rmk1 != null &&
      //       this.settlement.rmk2 != null &&
      //       this.settlement.rmk3 != null &&
      //       this.settlement.rmk4 != null &&
      //       this.settlement.rmk5 != null )
      // {
        doc.autoTable({
                head: [['Mis.Adjustment','Dedcutions','Additions']],
                body:[
                    [this.settlement.rmk1, this.settlement.rmk1Deduction, this.settlement.rmk1Addition],
                    [this.settlement.rmk2, this.settlement.rmk2Deduction, this.settlement.rmk2Addition],
                    [this.settlement.rmk3, this.settlement.rmk3Deduction, this.settlement.rmk3Addition],
                    [this.settlement.rmk4, this.settlement.rmk4Deduction, this.settlement.rmk4Addition],
                    [this.settlement.rmk5, this.settlement.rmk5Deduction, this.settlement.rmk5Addition]
                ],
                foot: [['Total Mis.Adjustment:',this.settlement.totMisDeduction, this.settlement.totMisAddition]]
                });
                // doc.text(200, +10,'Total Mis.Adjustment: '+ this.settlement.miscAdj);
      // };
        // doc.text(200,+20,'Net Settlement Amount: '+ this.settlement.netAmt);

      const awshost = location.host;
      var url = "https://named-account-web-dev.s3.us-west-2.amazonaws.com/PDF/Settle/" + this.settlement.payrollNumSeq + ".pdf";
        if (awshost.includes("-qas."))
        {
            url = "https://named-account-web-qas.s3.us-west-2.amazonaws.com/PDF/Settle/" + this.settlement.payrollNumSeq + ".pdf";
        }
        if (awshost.includes("-prd."))
        {
            url = "https://named-account-web-prd.s3.us-west-2.amazonaws.com/PDF/Settle/" + this.settlement.payrollNumSeq + ".pdf";
        }

      var PDFBase64 = btoa(doc.output())
      //api.post('/api/w/uploadPDF', {
      newAPIPost('/api/w/uploadPDF', {
        fileName: this.settlement.payrollNumSeq,
        imageBase64: PDFBase64,
        folder: "Settle"
      })
      .then(() => {
        // window.open("https://named-account-web-dev.s3.us-west-2.amazonaws.com/PDF/Settle/" + this.settlement.payrollNumSeq + ".pdf");
        window.open(url);  
        });
    },


    async doPrint(){
      const item = _(this.items).filter((it) => it.selected);
      this.settlement = item[0];

      //api.post('/api/w/apar/paysettle',
      newAPIPost('/api/w/apar/paysettle',
                  { mode:"update",
                    salesOffice: "LGB",
                    payrollNumSeq: this.settlement.payrollNumSeq,
                  }
                );


      //this.billings = await api.post('/api/w/apar/settelmentlist',
      this.billings = await newAPIPost('/api/w/apar/settelmentlist',
                  { mode:"print",
                    salesOffice: "LGB",
                    payrollNumSeq: this.settlement.payrollNumSeq,
                  }
                );

      let payrollprintitems = []

      // console.log ("BILLING TABLE DATA: "); 
      // console.log (JSON.stringify(this.billings)); 

      this.payrollprintitems = this.billings; 
      this.payrollprintitems.forEach(
        it => {
    
          it.payrollsort = it.billingDate +it.partner + it.tol + it.billingNum ; 
          it.tol = parseFloat(it.tol).toFixed(2); 
          it.amt = parseFloat(it.amt).toFixed(2); 
          // if(it.containerPickUpLocation == null )
          //     {
          //       it.containerPickUpLocation = 'FSI'
          //     }
          it.containerPickUpLocation = 'FSI' ; 
        }
      ); 

      this.payrollprintitems = _(this.payrollprintitems).sortBy('payrollsort'); 
      this.rownumber = 1 ;
      this.payrollprintitems.forEach(
        it => {
          it.rownumber = this.rownumber++ ; 
        }
      ); 

      this.totalrownumber  =  this.rownumber - 1 ; 
      this.drivercount =  this.payrollprintitems.map( x => x.partner).filter((v,i,s) => s.indexOf(v) === i).length; 
      this.settlement.totStdDeduction = ( parseFloat(this.settlement.amtScaleDeduction1) +
                                        parseFloat(this.settlement.amtManifestDeduction1) +
                                        parseFloat(this.settlement.amtParkingDeduction1) +
                                        parseFloat(this.settlement.amtInsuranceDeduction1)).toFixed(2);

      this.settlement.totStdAddition = (  parseFloat(this.settlement.amtScaleAddition1) +
                                  parseFloat(this.settlement.amtManifestAddition1) +
                                  parseFloat(this.settlement.amtParkingAddition1) +
                                  parseFloat(this.settlement.amtInsuranceAddition1)).toFixed(2);

      this.settlement.totMisDeduction = ( parseFloat(this.settlement.rmk1Deduction) +
                                  parseFloat(this.settlement.rmk2Deduction) +
                                  parseFloat(this.settlement.rmk3Deduction) +
                                  parseFloat(this.settlement.rmk4Deduction) +
                                  parseFloat(this.settlement.rmk5Deduction)).toFixed(2);

      this.settlement.totMisAddition = ( parseFloat(this.settlement.rmk1Addition) +
                                        parseFloat(this.settlement.rmk2Addition) +
                                        parseFloat(this.settlement.rmk3Addition) +
                                        parseFloat(this.settlement.rmk4Addition) +
                                        parseFloat(this.settlement.rmk5Addition)).toFixed(2);
      this.settlement.totoalAdj  = (
                                     - parseFloat(this.settlement.standardAdj)
                                     - parseFloat(this.settlement.miscAdj)

                                     ).toFixed(2);

      this.settlement.misAdjreason = "" ; 
        if (this.settlement.rmk1 !== null ) 
          {
            this.settlement.misAdjreason = this.settlement.rmk1 ; 
          } ; 

          if (this.settlement.rmk2 !== null ) 
          {
            this.settlement.misAdjreason = this.settlement.misAdjreason + "/" + this.settlement.rmk2; 
          } ; 
          if (this.settlement.rmk3 !== null ) 
          {
            this.settlement.misAdjreason = this.settlement.misAdjreason + "/" + this.settlement.rmk3; 
          } ; 
          if (this.settlement.rmk4 !== null ) 
          {
            this.settlement.misAdjreason = this.settlement.misAdjreason + "/" + this.settlement.rmk4; 
          } ; 
                                     
      this.settlement.company = this.getDisplay('STC_DRIVER_COMPANY', this.settlement.driverCompany);
      this.settlement.driver = 'Test Driver';
      const today = new Date();
      this.settlement.printDate =  moment(today).format('MM/DD/YYYY');
      this.settlement.settleWeekEnd = moment(this.settlement.settleDate).format('MM/DD/YYYY');
      this.payrollItem = this.settlement; 
      this.payrollItemStatus = true ; 
 
      },
  },
}
</script>